<template>
  <div class="h-100" v-if="tableData && tableLabels">
    <slot name="embedDeviceRegistrationMgmt" v-if="authMode"></slot>
    <div class="mst_table_btn_wrap" :style="{marginTop: tableNo === 'mstDevice' && authMode ? '0px !important' : '6px'}">
      <div
        class="table-toolbar"
        :class="(!hideChbxAllColumn && tableData.length !== 0) ? 'hideChbxAllColumn' : 'showChbxAllColumn'"
      >
        <div class="table-toolbar__block-left">
          <!-- 括削除用チェックボックス (Check box to select all) -->
          <div
            class="ml-0 mr-2"
            v-if="isMasterTableUnlocked && !hideChbxAllColumn && tableData.length !== 0"
          >
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              @change="toggleAll"
            />
          </div>
          <!-- 削除ボタン (Delete button) -->
          <div class="mr-2" v-show="isMasterTableUnlocked && (allSelected || indeterminate) && tableData.length">
            <button
              type="button"
              @click="onClickDelete('checked-delete')"
              class="btn btn_delete d-flex flex-row align-items-center"
            >
              <span class="icon_delete_btn material-icons material-icons-outlined pr-1 ">
                delete
              </span>
              {{removeKeys.length}}件を削除
            </button>
          </div>
          <!-- 総件数表示 (Total record count display) -->
          <div class="mr-2">
            <span class="totalRecord d-flex flex-row align-items-center" :style="{fontWeight: isCheckValueSearched || isShowBatchDetail() ? 'bold' : 'normal'}">
                {{ displayTotalRecords }}
            </span>
          </div>
          <!-- 追加ボタン (Add button) -->
          <div class="mr-2" v-if="isMasterTableUnlocked && !hideButtonAdd">
            <button
              @click="showAddModal(-1)"
              type="button"
              class="btn btn_add d-flex flex-row align-items-center"
            >
              <span class="icon_add_btn material-icons material-icons-outlined pr-1">
                add
              </span>
              追加
            </button>
          </div>
          <!-- 全て削除ボタン (Delete all button) -->
          <div class="mr-2" v-if="isMasterTableUnlocked && !hideButtonDeleteAll && tableData.length">
            <button
              type="button"
              class="btn btn_delete_all d-flex flex-row align-items-center"
              @click="onClickDelete('delete-all')"
            >
              <span class="icon_delete_btn material-icons material-icons-outlined pr-1 ">
                delete
              </span>
              全て削除
            </button>
          </div>
          <!-- 検索・フィルターボタン (Search/Filter button) -->
          <div class="mr-2" v-if="!hideButtonSearch">
            <button
              type="button"
              @click="showSearchModal"
              :class="[isCheckValueSearched ? 'handle_btn_search' : '']"
              class="btn btn_search d-flex flex-row align-items-center"
            >
              <span class="icon_search_btn material-icons material-icons-outlined pr-1">
                search
              </span>
              検索
            </button>
          </div>
          <!-- 検索条件クリアボタン (Clear search/filter button) -->
          <div v-if="isCheckValueSearched || isShowBatchDetail()" class="mr-2">
            <button
              type="button"
              @click="clearFilter"
              class="btn btn_filter_clear d-flex flex-row align-items-center"
            >
              <span class="icon_filter_clear_btn material-icons material-symbols-outlined pr-1">
                filter_alt_off
              </span>
              絞り込みクリア
            </button>
          </div>
          <!-- 並び順を元に戻すボタン (Revert sort order button) -->
          <div v-if="(sort.propetyName && sort.order)" class="mr-2">
            <button
              type="button"
              @click="revertSortOrder"
              class="btn revertSortBtn d-flex flex-row align-items-center"
            >
              <span class="revertSortIcon material-icons material-icons-outlined pr-1">
                undo
              </span>
              並び順クリア
            </button>
          </div>
          <div v-if="!hideButtonTableHeader" class="mr-2">
            <table-header-display-button
              :table-labels="tableLabels"
              v-on:header-display="headerDisplay"
            />
          </div>
          <!-- CSV アクションボタン (CSV action button) -->
          <div class="mr-2" v-if="!hideOrderButton">
            <other-button ref="extOtherButtonDropdown" buttonContent="CSV">
              <template v-slot:other-buttons>
                <csv-export-button
                  ref="csvExportButton"
                  :mapping-no="mappingNo"
                  :is-display-button="false"
                  @on-export="hideDropdownCsv"
                  @is-loading="(loading) => isLoading = loading"
                  :current-query-in-storage="currentQueryInStorage"
                  :on-export-success="handleExportSuccess"
                />
                <csv-import-button
                  v-if="isMasterTableUnlocked && !hideButtonImportCsv"
                  :mapping-no="mappingNo"
                  v-on:import="onImport"
                  v-on:is-loading="(loading) => isLoading = loading"
                  @on-import="hideDropdownCsv"
                />
              </template>
            </other-button>
          </div>
          <div class="mr-2">
            <slot name="overlap_button_preview_modal"></slot>
          </div>
          <!-- 開発設定アクションボタン (Dev Setting action button) -->
          <div class="mr-2" v-if="showDevSettingActionButton">
            <other-button ref="extOtherButtonDropdown" buttonContent="ツール">
              <template v-slot:other-buttons>
                <div v-for="button in buttonActionsConfig" :key="button.key">
                  <dev-setting-action-button :actionOptionLabel="button.actionOptionLabel"
                    @on-click-action-button="onClickActionButton(button.uri, button.modalTitle, button.confirmationDeleteMessage)"
                  />
                </div>
              </template>
            </other-button>
          </div>
        </div>
        <!-- ロックボタン (Lock button) -->
        <div class="table-toolbar__block-right" v-if="showLockMasterButton">
          <button
            type="button"
            class="btn btn-lock"
            @click="onClickLockButton"
            v-b-tooltip.hover.top.html="{
              variant: 'secondary',
              animation: true
            }"
            :title="isMasterTableUnlocked ? '編集できます' : '編集できません'">
              <img v-if="!isMasterTableUnlocked" src="../../assets/images/icon_lock.svg"/>
              <img v-else src="../../assets/images/icon_unlock_right.svg"/>
          </button>
        </div>
      </div>
        <!-- 検索モーダル (Search Modal) -->
        <search-modal-component
          v-if="tableLabels && tableLabels.length"
          v-on:search="onSubmit"
          titleModal="検索"
          :tableLabels="tableLabels"
          :query-prameter-value="queryPrameterValue"
          ref="searchModal"
          :table-data="tableData"
        />
    </div>
    <div class="mst_table_card cord shadow">
      <div class="table-responsive table_wrapper" id="table_common_master" ref="tableWrapper">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="true"
        />
        <table v-if="tableLabels.length" class="table sticky_table text-nowrap" ref="table">
          <thead>
            <draggable
              v-model="localTableLabels"
              tag="tr"
              draggable=".sort_th"
              :move="onMoveColumnOrder"
              @end="onEndColumnOrder"
              filter=".noAcceptDrag"
              :preventOnFilter="false"
              :disabled="hideIconDrag || isDisabledDragCol"
            >
              <th
                v-for="(t_label, index) in localTableLabels"
                :class="['sort_th', `sort_th${index}`, `data_type_${t_label.dataType}_${localTableLabels.length}`]"
                :key="t_label.tableManagementSerialId"
                :id="'col_header' + index"
                @mouseover="displayIconFilterAdDrag(t_label, index, true)"
                @mouseout="displayIconFilterAdDrag(t_label, index, false)"
                @click="showDialogFilter(index, $event)"
              >
                <template>
                  <span
                  :class="[
                    {
                      'justify-content-end': t_label.dataType === 1,
                      'justify-content-start': t_label.dataType === 0 || t_label.dataType === 2,
                      'justify-content-center': t_label.dataType === 3
                    },
                    'show-dropdown-region',
                    'tableThead',
                    'd-flex',
                    'align-items-center',
                    'text-nowrap'
                  ]">
                    <span
                      v-if="!hideIconDrag"
                      class="show-dropdown-region icon_drag text-info material-icons material-icons-outlined"
                      :id="'isDrag_' + index"
                      :style="{
                        visibility: 'hidden'
                      }"
                    >
                      drag_indicator
                    </span>
                    <span v-if="sort.propetyName === t_label.isItemNo && !hideSortOrder">
                      <span
                        v-if="sort.order === 1"
                        class="show-dropdown-region icon_sort text-info material-icons material-icons-outlined"
                      >
                        arrow_upward
                      </span>
                      <span
                        v-if="sort.order === 2"
                        class="show-dropdown-region icon_sort text-info material-icons material-icons-outlined">
                        arrow_downward
                      </span>
                    </span>
                    <!-- Label header -->
                    <editable-label
                      :text="t_label.itemName"
                      :maxlength=64
                      :id="'txt_header' + index"
                      :ref="'externalEditableLabel' + index"
                      v-on:text-updated="onEditItemName(...arguments, t_label)"
                      @single-click="showDialogFilterByLabel(...arguments, index)"
                      :disableChangeColumnName="disableChangeColumnName"
                    />
                  <!-- Handle icon dropdown filter - START -->
                    <filter-sort-dropdown
                      :index="index"
                      :sort="sort"
                      :tLabel="t_label"
                      :queryPrameterValue="queryPrameterValue"
                      @handleSortOrder="handleSortOrder"
                      @onSubmit="onSubmit"
                      @isDisabledDragCol="(isDrag) => isDisabledDragCol = isDrag"
                      :ref="'externalDropdownFilterSort' + index"
                      @allow-edit-label="onEditLabelHeader(index)"
                      :disableChangeColumnName="disableChangeColumnName"
                      :hideSortOrder="hideSortOrder"
                    >
                    <template v-slot:overlap_button_dialog>
                      <span
                        :style="{visibility: checkElementSearched(t_label) ? 'visible' : 'hidden'}"
                        :id="'isFilter_' + index"
                        class="material-icons material-icons-outlined text-info icon_filter"
                      >
                        filter_list
                      </span>
                      </template>
                    </filter-sort-dropdown>
                        <!-- Handle icon dropdown filter - END -->
                  </span>
                </template>
              </th>
              <template v-slot:header>
                <th class="first_col align-middle" style="width:48px" v-if="isMasterTableUnlocked && !hideFirstColHeader"></th>
                <th class="align-middle text-right col_ordinal_number">行番</th>
                <slot name="overlap_header" class="sort_th"></slot>
              </template>
            </draggable>
          </thead>
          <tbody class="tbody">
            <p v-if="!tableData.length && !isCheckValueSearched" class="empty_text">
              登録されていません。
            </p>
            <p v-else-if="!tableData.length && isCheckValueSearched" class="empty_text">
              検索結果がありません。
            </p>
            <tr
              v-else
              v-for="(itemData, index) in tableData"
              :key="`tbtr-${index}`"
              class="rowData"
            >
              <td v-if="isMasterTableUnlocked && !itemData.hideChbxColumn">
                <b-form-checkbox
                  v-model="removeKeys"
                  :value="itemData[primaryKey]"
                  @change="onRemovekeys"
                  name="tableData"
                  class="checkbox"
                />
              </td>
              <td v-if="tableNoDisplayEmptyColumn.includes(tableNo) && itemData.hideChbxColumn"></td>
              <td class="text-right" style="line-height: 2">{{ index + 1 }}</td>
              <slot
                @click="showEditModal(index)"
                name="overlap_body"
                v-bind:item="itemData"
              ></slot>
              <template v-for="(sortRow, idx) in sortValueKey">
                <template>
                  <td
                    @click="showEditModal(index, sortRow.keyName)"
                    :key="`tbtd-${idx}`"
                    :id="`${sortRow.keyName}-${idx}-${index}`"
                    v-show="displayVartical[sortRow.keyName]"
                    :class="[
                      {
                        'text-right': sortRow.dataType === 1,
                        'text-left': sortRow.dataType === 0 || sortRow.dataType === 2,
                        'text-center': sortRow.dataType === 3
                      },
                      'itemData'
                    ]"
                  >
                    {{ itemData[sortRow.keyName] | formatValueData(sortRow) | stripNewlineChar }}
                  </td>
                </template>
                <b-tooltip
                  v-if="fieldsWithTooltip && fieldsWithTooltip.includes(sortRow.keyName)"
                  :key="`mst-table-tooltip-${idx}`"
                  :target="`${sortRow.keyName}-${idx}-${index}`"
                  :title="getCellTooltipTitle(sortRow.keyName, itemData)"
                  triggers="hover"
                  placement="top"
                  custom-class="custom-tooltip"
                  animation="true"
                  variant="secondary"
                />
              </template>
            </tr>
          </tbody>
        </table>
        <infinite-loading
          @infinite="infiniteHandler"
          v-if="tableData.length"
          :distance="10"
          ref="infiniteLoading"
        >
          <div slot="no-results" v-if="showTableRowsOverLimitMsg" class="noMoreDataText">
            これ以上のスクロールはできません。ソート順を変えるか検索で絞り込んでください。
          </div>
        </infinite-loading>
        <add-edit-modal-component
          ref="modalAction"
          id="modal-action"
          :table-labels="tableLabels"
          :tableNo="tableNo"
          :noWorkTaskType="noWorkTaskType"
          :rejectChuteNo="rejectChuteNo"
          :option="indexRow === -1 ? addable : editable"
          :table-data="tableData"
          @action="onSubmitActionData"
          @delete-row="onClickDelete('delete', ...arguments)"
          :hideDeleteToAction="hideDeleteToAction"
          :hideSaveToAction="hideSaveToAction"
          :isSuccess="isSaveSuccess"
          @hide-modal="hideAddEditModal"
          :primaryKey="primaryKey"
          :tableApi="tableApi"
          :isLoading="isLoading"
          :isMasterTableUnlocked="isMasterTableUnlocked"
        />
        <delete-modal-component
          ref="confirmationDeleteModal"
          @on-delete="confirmDelete"
          :isShowConfirmDeleteCheckBox="isShowConfirmDeleteCheckBox"
          @on-delete-allowed="onConfirmDeleteAllowed"
          @on-restore-data-allowed="onRestoreDataAllowed"
          :titleHeader="modalConfirmDeleteTitle"
          :confirmationDeleteMessage="confirmationDeleteMessage"
          :isRestoreDataAllowed="showLockMasterButton && isMasterTableUnlocked"
        />
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Loading from 'vue-loading-overlay'
import DateFilterSortModal from './DateFilterSortModal.vue'
import NumberFilterSortModal from './NumberFilterSortModal.vue'
import TextFilterSortModal from './TextFilterSortModal.vue'
import 'vue-loading-overlay/dist/vue-loading.css'
import TableHeaderDisplayButton from '../custom-components/TableHeaderDisplayButton'
import CsvExportButton from '../custom-components/CsvExportButton'
import CsvImportButton from '../custom-components/CsvImportButton'
import OtherButton from '../custom-components/OtherButton'
import AddEditModalComponent from './AddEditModalComponent.vue'
import SearchModalComponent from './SearchModalComponent.vue'
import FlashMessage from '../../common/flash-message.component'
import EditableLabel from '../custom-components/EditableLabel'
import FilterableListbox from './FilterableListbox.vue'
import FilterSortDropdown from './FilterSortDropdown.vue'
import RouterUtils from '../../_helpers/router.util'
import AppConstants from '../../constants/app.constants'
import DeleteModalComponent from './DeleteModalComponent.vue'
import CommonUtils from '../../mixins/commonUtils.js'
import { mapActions, mapGetters, mapState } from 'vuex'
import { FieldDataType } from '../../enums/field-data-type.enums'
import StringUtils from '../../_helpers/string.util'
import DevSettingActionButton from '../custom-components/DevSettingActionButton'
const NEXT_LIST_COUNT = 50 // インフィニティスクロールの取得件数
const LIMIT_KEY = 'limit'
const OFFSET_KEY = 'offset'
const UPDATE_ACTION = 1
const INSERT_ACTION = 0
const DELETE_ACTION = 2
const RESET_ACTION = 3
const BATCH_NO_KEY = 'batchNo'
const BATCH_DETAIL_NO_KEY = 'batchDetailNo'
const SHOW_BATCH_DETAILS_KEY = 'showBatchDetails'
const TASK_TYPE_KEY = 'taskType'
const DELETE_ALL_MODE = 'delete-all'
const DEV_SETTINGS_TABLE_NO = 'mstDevSetting'
const URI_MAPPING_ENDPOINT = '/mapping'
// マスターテーブルのロック状態のデフォルト値
const DEFAULT_MASTER_TABLE_LOCK_STATE = {
  mstItem: false,
  mstChute: false,
  mstDetailDevice: false,
  mstInduction: false,
  mstShop: false,
  mstDevice: false,
  mstSorting: false,
  mstRcs: false
}
const moment = require('moment')
export default {
  components: {
    draggable,
    AddEditModalComponent,
    TextFilterSortModal,
    NumberFilterSortModal,
    DateFilterSortModal,
    TableHeaderDisplayButton,
    CsvImportButton,
    CsvExportButton,
    OtherButton,
    SearchModalComponent,
    Loading,
    EditableLabel,
    FilterableListbox,
    FilterSortDropdown,
    DeleteModalComponent,
    DevSettingActionButton
  },
  mixins: [CommonUtils],
  props: {
    hideChbxColumn: Boolean,
    primaryKey: String,
    tableNo: String,
    editable: {
      type: Object,
      default: function() {
        return {}
      }
    },
    addable: {
      type: Object,
      default: function() {
        return {}
      }
    },
    hideButtonAdd: Boolean,
    hideOrderButton: Boolean,
    hideButtonSearch: Boolean,
    hideChbxAllColumn: Boolean,
    hideFirstColHeader: Boolean,
    hideEditButton: Boolean,
    hideDeleteButton: Boolean,
    gridxSize: 0,
    gridySize: 0,
    mappingNo: null,
    hideDeleteToAction: Boolean,
    displayDialogViewDetail: Boolean,
    hideSaveToAction: Boolean,
    hideButtonImportCsv: Boolean,
    hideButtonDeleteAll: Boolean,
    tableApi: String,
    socketEntity: String,
    overlapMode: false,
    handleShowCheckBox: Boolean,
    emitEventOnManualDataFetching: false,
    removeKeyOptional: [],
    hideButtonTableHeader: false,
    hideIconDrag: false,
    disableChangeColumnName: false,
    hideSortOrder: false,
    fieldsWithTooltip: Array,
    showDevSettingActionButton: {
      type: Boolean,
      default: false
    },
    showLockMasterButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      totalRecords: 0,
      tableLabels: [], // original mstTableManagement (represented mstTableManagement in DB)
      tableData: [],
      isLoading: false,
      removeKeys: [],
      // eslint-disable-next-line no-array-constructor
      sortValueKey: new Array(),
      sort: { propetyName: null, order: null },
      limitData: {},
      isCheckValueSearched: false,
      allSelected: false,
      indeterminate: false,
      showIconDragById: null,
      queryPrameterValue: {},
      checkConfirm: null,
      indexRow: -1,
      offset: 0,
      tableLength: 0,
      movingIndex: null,
      futureIndex: null,
      isDisabledDragCol: null,
      isSaveSuccess: null,
      addNewForm: {},
      // eslint-disable-next-line no-undef
      authMode: config.AUTH_MODE,
      isEditingLabelHeader: false,
      columnsQueryValueHide: {},
      showTableRowsOverLimitMsg: false,
      overlap: 'mstChutesGridOverlap',
      overlapData: [],
      noWorkTaskType: [],
      rejectChuteNo: '',
      apiObjectRequest: {},
      currentQueryInStorage: '',
      tableNoDisplayEmptyColumn: ['trTask'],
      searchExacKeys: ['batchNo', 'batchDetailNo'],
      itemEdited: false,
      totalRecordsLimitInDb: 0,
      isShowConfirmDeleteCheckBox: false,
      endpointUri: '',
      modalConfirmDeleteTitle: '削除してもよろしいですか？',
      isDeleteConfirmationChecked: false,
      confirmationDeleteMessage: '',
      uriMappingEndpoint: URI_MAPPING_ENDPOINT,
      buttonActionsConfig: [],
      isMasterTableUnlocked: true,
      isRestoreDataConfirmChecked: true,
      isExportSuccess: false
    }
  },
  filters: {
    formatValueData(value, sortVal) {
      let reslutVal = value
      if (sortVal.dataType === FieldDataType.LIST) {
        reslutVal = sortVal.mstGenLabel[value] || value
      }
      if (value && sortVal.dataType === FieldDataType.DATE) {
        reslutVal = moment(value).format('L LT')
      }
      return reslutVal
    },
    /**
     * 文字列から改行文字を削除します。
     * @param {string} text 変換される文字列
     * @returns 「\\n」を含まない文字列を返します。
     */
    stripNewlineChar(text) {
      return text && text.toString().replace(/\\n/g, '')
    }
  },
  beforeCreate() {
    // Initialize the query object into localStorage according
    // to the current routeName with the query string being empty
    RouterUtils.initQueryObjectInStorage(this.$route.name, '')
  },
  created() {
    if (this.currentUrlQueryStr()) {
      this.currentQueryInStorage = this.currentUrlQueryStr()
    }
    // ロック状態が未保存の場合、デフォルト値を localStorage に保存する
    if (!localStorage.getItem(AppConstants.STORAGE_MASTER_TABLE_UNLOCK_STATE)) {
      localStorage.setItem(AppConstants.STORAGE_MASTER_TABLE_UNLOCK_STATE, JSON.stringify(DEFAULT_MASTER_TABLE_LOCK_STATE))
    }
  },
  async mounted() {
    await this.fetchData()
    this.tableLength = this.tableData.length
    // On Task Statement screen, when viewing batch details will check
    // and append field batchNo or batchDetailNo to data model using query
    // if either field is hidden
    if (this.isTaskStatementScreen()) {
      this.checkAppendItemQueryPrameterValue()
    }
    // アクションボタンの設定を初期化するメソッドです。
    this.initializeActionButtonsConfig()
  },
  watch: {
    tableData(newVal, oldVal) {
      this.tableData.forEach((itemData) => {
        this.$set(itemData, itemData.hideChbxColumn = this.hideChbxColumn)
      })
      this.tableLength = newVal.length
      if (this.$refs.infiniteLoading) {
        this.isReloaded = false
        this.$refs.infiniteLoading.stateChanger.reset()
      }
      if (this.handleShowCheckBox) {
        this.$emit('on-show-check-box')
      }
      // 選択したリストのserialIdがテーブル リストに存在しない場合、チェック ボタンがリセットされる
      if (this.removeKeys) {
        let primaryKeys = []
        if (this.handleShowCheckBox) {
          primaryKeys = newVal.map(item => {
            if (!item['hideChbxColumn']) {
              return item[this.primaryKey]
            }
          })
        } else {
          primaryKeys = newVal.map(item => item[this.primaryKey])
        }
        this.removeKeys = this.removeKeys.filter(serialId => {
          return primaryKeys.indexOf(serialId) !== -1
        })
        this.onChangeCheckAllButtonStyle(this.removeKeys)
      }
    },
    deep: true,
    removeKeys(newVal, oldVal) {
      this.onChangeCheckAllButtonStyle(newVal)
    },
    totalRecords(newVal, oldVal) {
      this.totalRecords = newVal
    },
    '$store.state.reconnectedFlag': async function(newValue) {
      if (newValue) {
        await this.fetchData()
      }
    },
    // データ テーブル ヘッダーを初期化または更新し、ストレージ内のクエリ文字列を更新します
    // ページをリロードするとき、または次のアクションを実行するとき: 列の表示/非表示、ヘッダー テーブルのラベル名を編集する、列を移動する
    localTableLabels: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.initialize()
        }
      },
      deep: true
    },
    // ソケットが変更され、通知されます
    messages(newValue, oldValue) {
      const mstTableMgmtSocketIsChanged = AppConstants.MST_TABLE_MANAGEMENT_PREFIX.concat(AppConstants[this.socketEntity])
      if (Array.isArray(newValue) && (newValue.includes(AppConstants[this.socketEntity]) || newValue.includes(mstTableMgmtSocketIsChanged) || this.checkSocketMsgToReloadOtherPage(newValue) || this.checkToReloadTableWithTotalRecordLimit(newValue))) {
        this.setMessages([])
        this.fetchData(true)
      }
    },
    apiObjectRequest(newVl, oldVl) {
      if (this.isSocketEnabled()) {
        this.onChangeQueryStrToCallApi(this.currentUrlQueryStr())
        this.resetQueryParameterValueModel()
      }
    }
  },
  computed: {
    displayVartical: function () {
      const newObject = this.localTableLabels.reduce((result, obj, index) => {
        result[obj.isItemNo] = parseInt(obj.displayFlag)
        return result
      }, {})
      return newObject
    },
    /**
     * local mstTableManagement (represented mstTableManagement in localstorage, containing changed item order for current PC)
     */
    localTableLabels: {
      get: function() {
        return this.$store.getters.getMstTable(this.tableNo)
      },
      set: function() {}
    },
    routeQuery: {
      get: function() {
        return this.$route.query
      },
      set: function() {}
    },
    /**
     * レコード総数表示を処理する。
     * 【検索中】または【バッチ詳細表示モード】の場合、検索結果であることをを文頭でアピール、
     * 【検索中でない】かつ【バッチ詳細表示モードでない】かつ【追加上限がある】場合、追加上限表示を文末に追加。
     * @returns {string} レコード総数表示
     */
    displayTotalRecords: function() {
      this.checkValueSearched()
      const showsBatchDetail = this.isShowBatchDetail()
      const searchResultStr = this.isCheckValueSearched || showsBatchDetail ? '検索結果：' : ''
      const totalRecordsStr = `${this.totalRecords}件`
      const totalRecordsLimitInDbStr = !this.isCheckValueSearched && !showsBatchDetail && this.totalRecordsLimitInDb ? `（${this.totalRecordsLimitInDb}件まで登録可能）` : ''
      return searchResultStr + totalRecordsStr + totalRecordsLimitInDbStr
    },
    ...mapState('socket', ['messages'])
  },
  methods: {
    /**
     * 開発設定フィールドのメッセージ ツールチップ メッセージを表示。
     * @param {string} keyName フィールド名
     * @param {object} itemData テーブル データ
     * @returns エスケープされていない改行文字のツールチップのタイトルを返します
     */
    getCellTooltipTitle(keyName, itemData) {
      return StringUtils.unescapeNewLineChar(itemData[keyName])
    },
    ...mapActions('socket', ['setMessages']),
    ...mapGetters('socket', ['isSocketEnabled']),
    async fetchData(isUpdateStorage = false) {
      const queryStr = this.onAppendLimitData(this.currentQueryInStorage)
      await this.fetchRequest(queryStr)
        .then(response => {
          const data = response.data
          this.tableLabels = data.mstTableManagement
          this.totalRecordsLimitInDb = data.totalRecordsLimit
          this.initData(response)
          this.noWorkTaskType = data['noWorkTaskType'] || []
          this.rejectChuteNo = data['rejectChuteNo']
          this.updateTableLabelsInLocalStorage(this.tableLabels)
          if (isUpdateStorage) {
            this.checkToShowErrorMsgOnEditModal(this.tableData)
          }
        })
        .catch(err => {
          console.log(err)
          this.buildErrorMessage(err)
        })
    },
    fetchDataForNewSocketMsg() {
      if (!this.isSocketEnabled()) {
        this.fetchRequest(this.onAppendLimitData(this.currentUrlQueryStr()))
          .then(response => {
            this.initData(response)
            this.resetQueryParameterValueModel()
          })
          .catch(err => {
            console.log(err)
            this.buildErrorMessage(err)
          })
        if (this.emitEventOnManualDataFetching) {
          this.$emit('manual-data-fetching')
        }
      }
    },
    /**
     * テーブルのデータを初期化する
     */
    initData(response) {
      if (!response || !response.data) {
        return
      }
      this.tableData = response.data[this.tableNo]
      this.totalRecords = response.data.totalRecords
      // For chute master screen
      if (response.data instanceof Object && response.data.hasOwnProperty(this.overlap)) {
        this.mapCommonResDataToModel(response)
        this.handleChuteGridOverlap(this.tableData)
      }
    },
    /** =========================
     * リクエストメソッド - 始める -
     =========================== */
    fetchRequest(querystr = '') {
      // ローカルストレージからロック状態を取得し、現在のテーブルのロック状態を設定（未定義の場合はアンロック）
      const lockMasterKey = JSON.parse(localStorage.getItem(AppConstants.STORAGE_MASTER_TABLE_UNLOCK_STATE)) || {}
      this.isMasterTableUnlocked = lockMasterKey.hasOwnProperty(this.tableNo) ? lockMasterKey[this.tableNo] : true
      return this.$axios.get(`${this.tableApi}${this.setRemitQuery(querystr)}`)
    },
    updateRequest(request) {
      this.apiObjectRequest = {}
      this.$set(this.apiObjectRequest, this.tableNo, request)
      return this.$axios.put(this.tableApi, this.apiObjectRequest)
    },
    createRequest(request) {
      this.apiObjectRequest = {}
      this.$set(this.apiObjectRequest, this.tableNo, request)
      return this.$axios.post(this.tableApi, this.apiObjectRequest)
    },
    deleteRequest(deleteObj) {
      this.apiObjectRequest = {}
      this.$set(this.apiObjectRequest, this.tableNo, deleteObj)
      return this.$axios.delete(this.tableApi, {
        data: this.apiObjectRequest
      })
    },
    deleteAllRequest() {
      this.apiObjectRequest = {}
      return this.$axios.delete(`${this.tableApi}/delete-all`)
    },
    headerDisplayRequest(data) {
      return this.$axios.put(`/table`, { mstTableManagement: [data] })
    },
    updateLabelHeaderRequest(mstTableManagement) {
      return this.$axios.put('/table', { mstTableManagement })
    },
    /** ========================= */
    currentUrlQueryStr() {
      return RouterUtils.getQueryString(this.$route.name)
    },
    onRemoveLimitData(query) {
      return query.replace(/&?limit=\d+/g, '')
    },
    /**
     * 指定された URI に対して DELETE リクエストを送信するメソッド。
     *
     * @param {string} uri - DELETE リクエストの対象となるエンドポイント URI
     * @returns {Promise} - Axios の DELETE リクエストの結果を返す Promise
     */
    async deleteRequestDevSetting(uri) {
      await this.$axios.delete(`${this.tableApi}${uri}`)
    },
    /**
     * 削除確認チェックの状態を更新するメソッド。
     *
     * @param {boolean} isDeleteConfirmationChecked - 削除確認がチェックされているかどうかを示すフラグ
     */
    onConfirmDeleteAllowed(isDeleteConfirmationChecked) {
      this.isDeleteConfirmationChecked = isDeleteConfirmationChecked
    },
    /**
     * 制限をクエリに追加
     * @param {string} query - 制限を追加するクエリ
     */
    onAppendLimitData(query) {
      let char = query ? '&' : '?'
      if (Object.keys(this.limitData).length) {
        if (query.indexOf('limit=') !== -1) {
          query = this.onRemoveLimitData(query)
        }
        query += `${char}limit=${this.limitData[LIMIT_KEY]}`
        RouterUtils.replaceUrlStr(query)
      }
      return query
    },
    checkToShowErrorMsgOnEditModal() {
      this.$refs.modalAction.checkToShowErrorMsgOnEditModal(this.itemEdited)
      this.itemEdited = false
    },
    // Check if object has data search or not
    checkValueSearched() {
      (Object.values(this.queryPrameterValue).every(
        x => x === null || x === '' || x.length === 0))
        ? (this.isCheckValueSearched = false)
        : (this.isCheckValueSearched = true)
    },
    // Show Modal Action - START -
    showEditModal(idx, itemNo) {
      this.indexRow = idx
      this.$refs.modalAction.showModal(idx, itemNo)
      this.$emit('show-modal-edit', {
        editItem: this.tableData[idx],
        noWorkTaskType: this.noWorkTaskType,
        rejectChuteNo: this.rejectChuteNo
      })
      FlashMessage.getInstance().hideAllErrorMessages(true)
    },
    showAddModal(index, itemNo = null) {
      this.indexRow = index
      this.$refs.modalAction.showModal(index, itemNo, this.addNewForm)
      FlashMessage.getInstance().hideAllErrorMessages(true)
    },
    showSearchModal() {
      this.$refs.searchModal.showModal()
      FlashMessage.getInstance().hideAllErrorMessages(true)
    },
    showDialogFilter(index, e) {
      // ユーザーが日付ピッカー アイコンをクリックしたときの問題を修正しました。
      if (typeof e.target.className !== 'string') {
        return
      }
      if (e.target.className.indexOf('show-dropdown-region') !== -1) {
        this.checkShowOrHideDialogFilter(index)
      }
    },
    showDialogFilterByLabel(e, index) {
      if (e.target.className.indexOf('editableLabel-label') !== -1) {
        this.checkShowOrHideDialogFilter(index)
      }
    },
    // Show Modal Action - END -
    /**
     * Trigger when the user completes the name change
     */
    async onEditItemName(editedLabelName, label) {
      // Get original mstTableManagement by the given label
      const databaseMstTableManagement = this.tableLabels.find(
        tableLabel =>
          tableLabel.tableManagementSerialId === label.tableManagementSerialId
      )
      if (!databaseMstTableManagement) {
        return
      }
      // Update new item name to mstTableManagement in database
      const clonedDbMstTableMgmt = {...databaseMstTableManagement}
      clonedDbMstTableMgmt.itemName = editedLabelName
      const mstTableManagement = [clonedDbMstTableMgmt]
      await this.updateLabelHeaderRequest(mstTableManagement)
      // Set new item name to original mstTableManagement (to match with database)
      databaseMstTableManagement.itemName = editedLabelName
      // Re-init table with original mstTableManagement and changed item order stored in local storage
      this.updateTableLabelsInLocalStorage(this.tableLabels)
    },
    /**
     * Handle select all records to delete
     */
    toggleAll(checked) {
      this.removeKeys = []
      if (checked) {
        this.tableData.forEach((dataRow) => {
          if (!dataRow['hideChbxColumn']) {
            this.removeKeys.push(dataRow[this.primaryKey])
          }
        })
      }
    },
    /** =========================
     * CsvImportButton
     =========================== */
    async onImport() {
      // import後の処理
      // 再検索
      this.resetCheckAll()
      this.fetchDataForNewSocketMsg()
    },
    /**
     * ソート順を削除
     */
    removeSortOrder() {
      if (this.columnsQueryValueHide.hasOwnProperty(this.sort.propetyName)) {
        this.sort = { propetyName: null, order: null }
      }
    },
    /**
     * 追加の制限とオフセット
     *
     * @param {string} query - 制限とオフセットを追加するクエリ
     * @return {sting} - クエリ文字列。
     */
    onAppendLimitOffset(query) {
      let char = query ? '&' : '?'
      var requestUrl = ''
      // if the first  add limit
      if (!Object.keys(this.limitData).length) {
        requestUrl = `${OFFSET_KEY}=${NEXT_LIST_COUNT}&${LIMIT_KEY}=${NEXT_LIST_COUNT}`
        // Setting the value of limit and offset
        this.offset = NEXT_LIST_COUNT
        this.limitData[LIMIT_KEY] = NEXT_LIST_COUNT * 2
      } else {
        var offsetVal = this.limitData[LIMIT_KEY]
        requestUrl = `${OFFSET_KEY}=${offsetVal}&${LIMIT_KEY}=${NEXT_LIST_COUNT}`
        this.offset = offsetVal
        this.limitData[LIMIT_KEY] = offsetVal + NEXT_LIST_COUNT
      }
      return `${query}${char}${requestUrl}`
    },
    /**
     * キー名が存在することを確認します
     * @param  {string} keyName - キー名
     * @return {boolean} { true: 存在, false: 存在しない }
     */
    checkKeyNameExisInSortValueKey(keyName) {
      return this.sortValueKey.some(obj => obj.keyName === keyName)
    },
    /**
     * クエリ パラメータ モデルの更新
     */
    updateQueryParameterModel() {
      const queryObject = RouterUtils.getQueryObjectFromStorageByRouterName(this.$route.name)
      if (this.isShowBatchDetail()) {
        // Add batchDetailNo column when not exist in the table
        const batchDetailnoExist = this.checkKeyNameExisInSortValueKey(BATCH_DETAIL_NO_KEY)
        if (queryObject.hasOwnProperty(BATCH_DETAIL_NO_KEY) && !batchDetailnoExist) {
          this.sortValueKey.unshift({
            dataType: 1,
            keyName: BATCH_DETAIL_NO_KEY,
            mstGenLabel: {}})
        }

        // Add batchNo column when not exist in the table
        const batchNoExist = this.checkKeyNameExisInSortValueKey(BATCH_NO_KEY)
        if (queryObject.hasOwnProperty(BATCH_NO_KEY) && !batchNoExist) {
          this.sortValueKey.unshift({
            dataType: 0,
            keyName: BATCH_NO_KEY,
            mstGenLabel: {}})
        }
      }
      this.sortValueKey.forEach(sortRow => {
        // ソートされたタスク タイプがタスク タイプ リストに存在するかどうかを確認し、
        // 存在しない場合はソーターでこのタスク タイプを削除します。
        if (sortRow.keyName === TASK_TYPE_KEY && queryObject[TASK_TYPE_KEY] &&
            Object.keys(sortRow.mstGenLabel).length) {
          // キー名のこの値が配列でない場合は、配列に変換します。
          if (!Array.isArray(queryObject[sortRow.keyName])) {
            queryObject[sortRow.keyName] = [queryObject[sortRow.keyName]]
          }
          for (let i = 0; i < queryObject[sortRow.keyName].length; i++) {
            const elm = queryObject[sortRow.keyName][i]
            if (!Object.keys(sortRow.mstGenLabel).includes(elm)) {
              queryObject[sortRow.keyName][i] = null
            }
          }
        }
        this.initQueryParameterModel(queryObject[sortRow.keyName], sortRow.dataType, sortRow.keyName)
      })
    },
    /**
     * リミットとオフセットをリセットします。
     */
    resetLimitOffset() {
      this.$refs.tableWrapper.scrollTop = 0
      this.limitData = {}
      this.offset = 0
    },
    /**
     * 並べ替え順を更新
     */
    updateSortOrder() {
      let routeQuerySort = RouterUtils.getQueryObjectFromStorageByRouterName(this.$route.name)['sort']
      if (routeQuerySort) {
        if (routeQuerySort.startsWith('-')) {
          // sort DESC
          this.sort.order = 2
          this.sort.propetyName = routeQuerySort.substring(1)
        } else {
          // sort ASC
          this.sort.order = 1
          this.sort.propetyName = routeQuerySort
        }
      }
    },
    /**
     * ヘッダーを表示
     * @param {object} displayValue - オブジェクト列の表示/非表示
     */
    async headerDisplay(displayValue) {
      const objFromStorage = RouterUtils.getQueryObjectFromStorageByRouterName(this.$route.name)
      // Reset limit offset when hide column
      if (!displayValue.displayFlag) {
        this.resetLimitOffset()
        // Reset value search related to hidden column
        this.resetValueOfColumn(displayValue.isItemNo)
      }
      // Check if search exac is true and if key name is included in the searchExacKeys array
      if (Object.keys(objFromStorage).length && !displayValue.displayFlag) {
        // Not show batch details or it shows batch details but the column name is not included searchExacKeys
        if (!this.isShowBatchDetail() || !this.searchExacKeys.includes(displayValue.isItemNo)) {
          // Find the index of the element in the array that matches the hidden column name
          const foundIndex = this.sortValueKey.findIndex(obj => { return obj['keyName'] === displayValue.isItemNo })
          const indexColHide = this.localTableLabels.findIndex(col => col.isItemNo === displayValue.isItemNo)
          // Check if the foundIndex is not equal to -1, meaning it is found in to remove the item in array
          if (foundIndex !== -1 && indexColHide !== -1) {
            this.sortValueKey.splice(foundIndex, 1)
            this.localTableLabels.splice(indexColHide, 1)
            this.parseQueryObjectToString()
            this.onChangeQueryStrToCallApi(this.currentUrlQueryStr())
          }
          // Add search key to object
          this.columnsQueryValueHide[displayValue.isItemNo] = objFromStorage[displayValue.isItemNo]
        }
        // Get condition sort
        const curSort = this.getSortCondition()
        if (curSort) {
          // Add sort key to object
          this.columnsQueryValueHide['sort'] = curSort
        }
      }
      // Removes it from the specified object when the column is displayed
      if (displayValue.displayFlag && this.columnsQueryValueHide.hasOwnProperty(displayValue.isItemNo)) {
        delete this.columnsQueryValueHide[displayValue.isItemNo]
        delete this.columnsQueryValueHide['sort']
      }
      await this.headerDisplayUpdate(displayValue)
      await this.fetchDataForNewSocketMsg()
    },
    // Submit add/edit modal
    async onSubmitActionData(data) {
      if (this.indexRow < 0) {
        await this.tackleAddNewData(data)
      } else {
        await this.tackleUpdateData(data)
      }
      this.fetchDataForNewSocketMsg()
    },
    // Submit dialog filters (text, number, date)
    async onSubmit(queryParam, isFilterList = false, isResetRemoveKeys = false) {
      if (isFilterList) {
        this.queryPrameterValue[queryParam.itemNo] = [...queryParam.selected]
      } else {
        this.queryPrameterValue = { ...queryParam }
      }
      this.resetHiddenColumnSearchSortValue()
      if (isResetRemoveKeys) {
        this.removeKeys = []
      }
      this.resetLimitOffset()
      RouterUtils.removeSearchExacFromStorage(this.$route.name)
      this.updateSortingKeys()
      await this.handleSearchMasterMethod(this.parseQueryObjectToString())
      this.checkValueSearched()
    },
    /**
     * 列を順番に並べ替える
     * @return {string} 並べ替え順序
     */
    sortColumnByOrder() {
      // ソート指定があればqueryStringsに追加
      return this.sort.order === 1 ? `${this.sort.propetyName}` : `-${this.sort.propetyName}`
    },
    async handleSortOrder(data) {
      this.sort = {...data}
      const queryString = this.onAppendLimitData(this.parseQueryObjectToString())
      await this.handleSearchMasterMethod(queryString)
    },
    // Submit data modal - END -
    checkShowOrHideDialogFilter(index) {
      const isShowDialogFilter = this.$refs['externalDropdownFilterSort' + index][0].isShow
      isShowDialogFilter
        ? this.$refs['externalDropdownFilterSort' + index][0].hideDialogFilter()
        : this.$refs['externalDropdownFilterSort' + index][0].showDialogFilter()
    },
    onChangeQueryStrToCallApi(query) {
      this.currentQueryInStorage = query
    },
    buildValueObjectNotNull(obj) {
      if (obj && Object.keys(obj).length > 0) {
        // Filter value object not null
        return {...Object.entries(obj).reduce(
          (elData, [keyField, valueField]) => (valueField || valueField === 0 ? ((elData[keyField] = valueField), elData) : elData),
          {}
        )}
      }
      return {}
    },
    updateTableLabelsInLocalStorage(tableLabels) {
      // Override related table store with below values:
      // original mstTableManagement (represented mstTableManagement in DB, containing changed item name and displayed flag)
      // and changed item order (stored in local storage)
      const filteredTableLabels = JSON.parse(JSON.stringify(tableLabels))
      this.$store.commit('setMstTable', {tableList: filteredTableLabels, tableNo: this.tableNo})
    },
    initialize() {
      this.sortValueKey = []
      for (let key in this.localTableLabels) {
        let dataType = this.localTableLabels[key]['dataType']
        let keyName = this.localTableLabels[key]['isItemNo']
        let mstGen = {}
        if (this.localTableLabels[key].mstGenCode) {
          this.localTableLabels[key].mstGenCode.forEach(gen => {
            mstGen[gen.code] = gen.name
          })
        }
        this.sortValueKey.push({
          dataType,
          keyName: keyName,
          mstGenLabel: mstGen
        })
      }
      this.updateQueryParameterModel()
      this.updateSortOrder()
      this.resetHiddenColumnSearchSortValue()
      this.parseQueryObjectToString(true)
      this.checkValueSearched()
    },
    resetQueryParameterValueModel() {
      // Resets sort value when column name exists in specified object
      this.removeSortOrder()
      this.updateQueryParameterModel()
      this.checkValueSearched()
    },
    initQueryParameterModel(routeQuery, dataType, keyName) {
      switch (dataType) {
        case FieldDataType.STRING:
          this.$set(this.queryPrameterValue, `${keyName}`, routeQuery ? routeQuery.toString() : null)
          break
        case FieldDataType.NUMBER:
          let numberQuerys = routeQuery || []
          if (!Array.isArray(numberQuerys)) {
            numberQuerys = [numberQuerys]
          }
          this.$set(
            this.queryPrameterValue,
            `before_${keyName}`,
            (parseInt(numberQuerys[0]) || parseInt(numberQuerys[0]) === 0) ? parseInt(numberQuerys[0]) : null
          )
          this.$set(
            this.queryPrameterValue,
            `after_${keyName}`,
            (parseInt(numberQuerys[1]) || parseInt(numberQuerys[1]) === 0) ? parseInt(numberQuerys[1]) : null
          )
          break
        case FieldDataType.LIST:
          let listQuerys = routeQuery || []
          if (!Array.isArray(listQuerys)) {
            listQuerys = [listQuerys]
          }
          let result = listQuerys.filter(item => item !== null).map(function (x) {
            return parseInt(x)
          })
          this.$set(this.queryPrameterValue, keyName, result)
          break
        case FieldDataType.DATE:
          let dateQueryStrs = routeQuery || []
          if (!Array.isArray(dateQueryStrs)) {
            dateQueryStrs = [dateQueryStrs]
          }
          dateQueryStrs[0] = dateQueryStrs[0]
            ? dateQueryStrs[0].replace(' 00:00:00', '')
            : null
          dateQueryStrs[1] = dateQueryStrs[1]
            ? dateQueryStrs[1].replace(' 23:59:59', '')
            : null
          this.$set(
            this.queryPrameterValue,
            `before_${keyName}`,
            dateQueryStrs[0] || null
          )
          this.$set(
            this.queryPrameterValue,
            `after_${keyName}`,
            dateQueryStrs[1] || null
          )
          break
      }
    },
    async onRemovekeys() {
      await this.$nextTick()
    },
    /**
     * Trigger drag column
     */
    onMoveColumnOrder(event) {
      const { index, futureIndex } = event.draggedContext
      this.movingIndex = index
      this.futureIndex = futureIndex
      return false // disable sort
    },
    /**
     * End dragging the column
     */
    async onEndColumnOrder(e) {
      if (this.movingIndex === null || this.futureIndex === null) {
        return
      }
      const fullMstTable = this.$store.getters.getMstTable(this.tableNo, false)
      if (this.futureIndex === fullMstTable.length) {
        this.futureIndex = fullMstTable.length - 1
      }
      const targetOrder = this.localTableLabels[this.futureIndex].itemOrder
      const originalLabel = this.localTableLabels[this.movingIndex]
      const originalOrder = originalLabel.itemOrder
      const isDragToRight = originalOrder < targetOrder
      const increment = isDragToRight ? 1 : -1
      while (originalLabel.itemOrder !== targetOrder) {
        const nextGreaterOrder = fullMstTable.find(
          label => label.itemOrder === originalLabel.itemOrder + increment
        )
        this.swapLabelOrder(originalLabel, nextGreaterOrder, isDragToRight)
      }
      // Update new item order to related table store and localstorage
      const changedLabel = originalLabel
      this.$store.commit('updateTableInState', {
        tableList: changedLabel,
        tableNo: this.tableNo
      })
      // Re-init table with original mstTableManagement and changed item order (from local storage)
      this.updateTableLabelsInLocalStorage(this.tableLabels)
      this.movingIndex = null
      this.futureIndex = null
    },
    swapLabelOrder(oldTableLabels, newTableLabels, isSmaller) {
      const oldOrder = oldTableLabels.itemOrder
      const newOrder = newTableLabels.itemOrder
      if (oldOrder !== newOrder) {
        oldTableLabels.itemOrder = newOrder
        newTableLabels.itemOrder = oldOrder
        return
      }
      if (isSmaller) {
        oldTableLabels.itemOrder++
      } else {
        newTableLabels.itemOrder++
      }
    },
    /** ============================================================================
     * URLに付与するリクエストパラメーターを作成
     * @param {boolean} infiniteScrollData - 無限スクロール データ取得
     ============================================================================ */
    parseQueryObjectToString(infiniteScrollData = false) {
      var queryStrings = []
      this.sortValueKey.forEach(sortRow => {
        // ソート指定があればqueryStringsに追加
        if (this.sort.propetyName === sortRow.keyName) {
          queryStrings.push(`sort=${this.sortColumnByOrder()}`)
        }
        if (!this.isShowBatchDetail()) {
          let value = this.queryPrameterValue[sortRow.keyName]
          switch (sortRow.dataType) {
            case FieldDataType.STRING:
              if (value) queryStrings.push(`${sortRow.keyName}=${encodeURIComponent(value)}`)
              break
            case FieldDataType.NUMBER:
              let before = this.queryPrameterValue[`before_${sortRow.keyName}`]
              let after = this.queryPrameterValue[`after_${sortRow.keyName}`]
              if (typeof before !== 'object' && typeof before !== 'string' &&
                typeof after !== 'object' && typeof after !== 'string') {
                queryStrings.push(
                  `${sortRow.keyName}=${before}&${sortRow.keyName}=${after}`
                )
              } else {
                if (typeof before !== 'object' && typeof before !== 'string') {
                  queryStrings.push(`${sortRow.keyName}=${before}`)
                }
                if (typeof after !== 'object' && typeof after !== 'string') {
                  queryStrings.push(`${sortRow.keyName}=${after}`)
                }
              }
              break
            case FieldDataType.LIST:
              Object.keys(value || {}).forEach(listObjectKey => {
                queryStrings.push(
                  `${sortRow.keyName}=${parseInt(value[listObjectKey])}`
                )
              })
              break
            case FieldDataType.DATE:
              let beforeDate = this.queryPrameterValue[`before_${sortRow.keyName}`]
              let afterDate = this.queryPrameterValue[`after_${sortRow.keyName}`]
              let beforeTime = this.convertDateToTime(beforeDate)
              let afterTime = this.convertDateToTime(afterDate)
              if (beforeDate && afterDate) {
                if (beforeTime < afterTime) {
                  queryStrings.push(
                    `${sortRow.keyName}=${beforeDate} 00:00:00&${sortRow.keyName}=${afterDate} 23:59:59`
                  )
                } else {
                  queryStrings.push(
                    `${sortRow.keyName}=${afterDate} 00:00:00&${sortRow.keyName}=${beforeDate} 23:59:59`
                  )
                }
              } else {
                if (beforeDate) {
                  queryStrings.push(`${sortRow.keyName}=${beforeDate} 00:00:00&${sortRow.keyName}=${beforeDate} 23:59:59`)
                }
                if (afterDate) {
                  queryStrings.push(`${sortRow.keyName}=${afterDate} 00:00:00&${sortRow.keyName}=${afterDate} 23:59:59`)
                }
              }
              break
            default:
              console.log(
                sortRow.dataType + ' : データタイプの指定が間違えています'
              )
              break
          }
        }
      })
      var queryParameterString = ''
      if (this.isShowBatchDetail()) {
        // Add batchNo - batchDetailNo-showBatchDetails to build query string
        const objectFromStorage = RouterUtils.getQueryObjectFromStorageByRouterName(this.$route.name)
        queryStrings.push(`${BATCH_NO_KEY}=${encodeURIComponent(objectFromStorage[BATCH_NO_KEY])}`)
        queryStrings.push(`${BATCH_DETAIL_NO_KEY}=${objectFromStorage[BATCH_DETAIL_NO_KEY]}`)
        queryStrings.push(`${SHOW_BATCH_DETAILS_KEY}=true`)
      }
      for (var i = 0; i < queryStrings.length; i++) {
        const query = (!i ? '?' : '&') + queryStrings[i]
        queryParameterString += query
      }
      if (infiniteScrollData) {
        this.onChangeQueryStrToCallApi(queryParameterString)
        RouterUtils.replaceUrlStr(this.onAppendLimitData(queryParameterString))
      } else {
        RouterUtils.replaceUrlStr(queryParameterString)
      }
      RouterUtils.updateQueryObjectToStorage(this.$route.name, queryParameterString)
      return queryParameterString
    },
    // On Task Statement screen, if exist search exact and batchNo or batchDetailNo columns hidden
    // append batchNo or batchDetailNo field into query parameter value model
    checkAppendItemQueryPrameterValue() {
      if (!this.isShowBatchDetail()) {
        return
      }
      const isExistingBatchNo = this.queryPrameterValue.hasOwnProperty(BATCH_NO_KEY)
      const isExistingBatchDetailNo = this.queryPrameterValue.hasOwnProperty('before_batchDetailNo')
      if (!isExistingBatchNo) {
        this.$set(this.queryPrameterValue, BATCH_NO_KEY, this.$route.query.batchNo)
        this.columnsQueryValueHide[BATCH_NO_KEY] = this.$route.query.batchNo
      }
      if (!isExistingBatchDetailNo) {
        this.$set(this.queryPrameterValue, 'before_batchDetailNo', parseInt(this.$route.query.batchDetailNo))
        this.columnsQueryValueHide[BATCH_DETAIL_NO_KEY] = parseInt(this.$route.query.batchDetailNo)
      }
    },
    infiniteHandler($state) {
      // Check the existence of showBatchDetail param before handling logic to remove it.
      this.showTableRowsOverLimitMsg = false
      if ((this.offset + NEXT_LIST_COUNT) >= this.totalRecords) {
        $state.complete()
        return
      }
      // eslint-disable-next-line no-undef
      if (this.tableLength >= config.TABLE_ROWS_LIMIT) {
        this.showTableRowsOverLimitMsg = true
        $state.complete()
        return
      }
      if (
        !this.isReloaded &&
        this.$refs.tableWrapper.clientHeight - NEXT_LIST_COUNT >
          this.$refs.table.clientHeight
      ) {
        this.isReloaded = true
        return $state.error()
      }
      this.isReloaded = false
      const paramString = this.parseQueryObjectToString()
      const requestUrl = this.onAppendLimitOffset(paramString)
      const queryString = this.onAppendLimitData(paramString)
      const data = {
        state: $state,
        requestUrl: requestUrl,
        queryStr: queryString
      }
      this.infiniteHandlerUpdate(data)
    },
    /**
     * When the user chooses to edit the name in the dialog filter
     */
    onEditLabelHeader(index) {
      this.$refs['externalDropdownFilterSort' + index][0].hideDialogFilter()
      this.$refs['externalEditableLabel' + index][0].switchToEditMode()
    },
    /**
     * Check eixst value search element - display icon filter on header table
     */
    checkElementSearched(tLabel) {
      if (!tLabel) {
        return false
      }
      switch (tLabel.dataType) {
        case FieldDataType.STRING:
          if (this.queryPrameterValue[tLabel.isItemNo]) {
            return true
          }
          return false
        case FieldDataType.LIST:
          const list = this.queryPrameterValue[tLabel.isItemNo]
          if (list && list.length !== 0) {
            return true
          }
          return false
        case FieldDataType.NUMBER:
          const before = this.queryPrameterValue[`before_${tLabel.isItemNo}`]
          const after = this.queryPrameterValue[`after_${tLabel.isItemNo}`]
          if (Number.isInteger(before) || Number.isInteger(after)) {
            return true
          }
          return false
        case FieldDataType.DATE:
          const beforeDate = this.queryPrameterValue[`before_${tLabel.isItemNo}`]
          const afterDate = this.queryPrameterValue[`after_${tLabel.isItemNo}`]
          if ((typeof beforeDate !== 'object' && beforeDate !== '') ||
              (typeof afterDate !== 'object' && afterDate !== '')) {
            return true
          }
          return false
        default:
          break
      }
    },
    /**
     * handle check display icon filter and icon drag on header table
     */
    displayIconFilterAdDrag(tLabel, index, isCheck) {
      let styleIconFil = document.getElementById(`isFilter_${index}`).style
      let styleDrag = document.getElementById(`isDrag_${index}`)
      if (this.checkElementSearched(tLabel)) {
        styleIconFil.visibility = 'visible'
      } else {
        isCheck ? styleIconFil.visibility = 'visible'
          : styleIconFil.visibility = 'hidden'
      }
      if (!styleDrag) {
        return
      }
      if (isCheck) styleDrag.style.visibility = 'visible'
      if (!isCheck) styleDrag.style.visibility = 'hidden'
    },
    revertSortOrder() {
      this.handleSortOrder({ propetyName: null, order: null })
    },
    clearFilter() {
      for (let key in this.queryPrameterValue) {
        this.queryPrameterValue[key] = null
      }
      this.onSubmit(this.queryPrameterValue, false, true)
    },
    setLoading(value) {
      this.isLoading = value
    },
    isSubmitSuccessful(check) {
      this.isSaveSuccess = check
    },
    hideAddEditModal(formData) {
      this.addNewForm = {...formData}
    },
    hideDropdownCsv() {
      this.$refs.extOtherButtonDropdown.hideDropdown()
    },
    resetCheckAll() {
      this.removeKeys = []
    },
    // Upate sorting keys to build tbody data on master table
    updateSortingKeys() {
      this.sortValueKey = []
      for (let key in this.localTableLabels) {
        let dataType = this.localTableLabels[key]['dataType']
        let keyName = this.localTableLabels[key]['isItemNo']
        let mstGen = {}
        if (this.localTableLabels[key].mstGenCode) {
          this.localTableLabels[key].mstGenCode.forEach(gen => {
            mstGen[gen.code] = gen.name
          })
        }
        this.sortValueKey.push({
          dataType,
          keyName: keyName,
          mstGenLabel: mstGen
        })
      }
    },
    // For chute master screen
    $_isOverlap(chuteSerialId) {
      if (!this.overlapData) {
        return false
      }
      return this.overlapData.indexOf(chuteSerialId) > -1
    },
    /**
     * モデルに共通レスポンスデータを連携する
     */
    mapCommonResDataToModel(response) {
      if (!response || !response.data) {
        return
      }
      this.overlapData = response.data[this.overlap]
    },
    // Handle search API request for master components
    async handleSearchMasterMethod(queryStr) {
      this.onChangeQueryStrToCallApi(queryStr)
      await this.searchRequest(queryStr)
      this.resetQueryParameterValueModel()
    },
    // API handler methods to update - START
    async tackleDeleteAll() {
      try {
        this.setLoading(true)
        if (DEFAULT_MASTER_TABLE_LOCK_STATE.hasOwnProperty(this.tableNo) && this.isRestoreDataConfirmChecked) {
          await this.$refs.csvExportButton.onCsvExport()
          if (!this.isExportSuccess) {
            this.setLoading(false)
            return
          }
        }
        await this.deleteAllRequest()
        this.onAppendLimitData(this.parseQueryObjectToString())
        this.resetCheckAll()
        this.buildSuccessMessage(DELETE_ACTION)
      } catch (err) {
        this.setLoading(false)
        this.buildErrorMessage(err)
      }
      this.setLoading(false)
    },
    // チェック項目の削除ボタン処理
    async tackleDeleteOnCheckedRows(index) {
      let removeItems = []
      if (index || index === 0) {
        removeItems.push(this.tableData[index])
      } else {
        const deepCopy = Array.from(this.removeKeys)
        this.tableData.forEach(dataRow => {
          for (var i = 0; i < deepCopy.length; i++) {
            if (deepCopy[i] !== dataRow[this.primaryKey]) continue
            removeItems.push(dataRow)
            deepCopy.splice(i, 1)
          }
        })
      }
      try {
        this.setLoading(true)
        const response = await this.deleteRequest(removeItems)
        this.mapCommonResDataToModel(response)
        this.onAppendLimitData(this.parseQueryObjectToString())
        this.buildSuccessMessage(DELETE_ACTION)
      } catch (err) {
        this.setLoading(false)
        this.buildErrorMessage(err)
      }
      this.setLoading(false)
    },
    /**
     * 開発者設定に関連するリソースを削除する非同期メソッド。
     */
    async tackleDeleteFromDevSetting() {
      try {
        this.setLoading(true)
        await this.deleteRequestDevSetting(this.endpointUri)
        let action = this.endpointUri === URI_MAPPING_ENDPOINT ? RESET_ACTION : DELETE_ACTION
        this.buildSuccessMessage(action)
      } catch (err) {
        this.buildErrorMessage(err)
      } finally {
        this.setLoading(false)
      }
    },
    async tackleUpdateData(updateItem) {
      this.setLoading(true)
      this.itemEdited = true
      await this.updateRequest(updateItem)
        .then(response => {
          const isOverlap = this.isOverlap(response)
          this.mapCommonResDataToModel(response)
          this.setLoading(false)
          this.buildSuccessMessage(UPDATE_ACTION, isOverlap)
          this.$root.$emit('bv::hide::modal', 'modal-action')
        })
        .catch(err => {
          this.itemEdited = false
          this.setLoading(false)
          this.buildErrorMessage(err)
        })
    },
    async tackleAddNewData(insertItem) {
      this.setLoading(true)
      try {
        const response = await this.createRequest(insertItem)
        const isOverlap = this.isOverlap(response)
        this.mapCommonResDataToModel(response)
        this.setLoading(false)
        this.isSaveSuccess = true
        this.buildSuccessMessage(INSERT_ACTION, isOverlap)
        this.$root.$emit('bv::hide::modal', 'modal-action')
      } catch (err) {
        console.log(err)
        this.setLoading(false)
        this.isSaveSuccess = false
        this.buildErrorMessage(err)
      }
      return this.isSaveSuccess
    },
    /**
     * 重複グリッド メッセージを表示する場合にオンにします
     */
    isOverlap(response) {
      if (response && response.data && response.data[this.overlap]) {
        return response.data[this.overlap].length > 0
      }
      return false
    },
    async headerDisplayUpdate(data) {
      this.isLoading = true
      await this.headerDisplayRequest(data)
        .then(res => {
          // Set display flag to original mstTableManagement (to match with database)
          let updatedObj = res.data.mstTableManagement[0]
          const index = this.tableLabels.findIndex(col => col.isItemNo === updatedObj.isItemNo)
          if (index !== -1) {
            this.$set(this.tableLabels, index, updatedObj)
            // Re-init table with original mstTableManagement and changed item order (from local storage)
            if (!this.isSocketEnabled()) {
              this.updateTableLabelsInLocalStorage(this.tableLabels)
            }
          }
          this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
          this.buildErrorMessage(err)
        })
    },
    infiniteHandlerUpdate(data) {
      this.fetchRequest(data.requestUrl)
        .then(response => {
          const resluts = response.data[this.tableNo]
          if (!resluts.length) {
            return data.state.complete()
          } else {
            RouterUtils.replaceUrlStr(data.queryStr)
            this.removeSortOrder()
            // check to update query object parameter
            if (Object.keys(this.columnsQueryValueHide).length) {
              this.updateQueryParameterModel()
            }
            this.checkValueSearched()
            // For chute master screen
            if (response.data instanceof Object && response.data.hasOwnProperty(this.overlap)) {
              this.mapCommonResDataToModel(response)
            }
            this.totalRecords = response.data.totalRecords
            this.tableData.push(...resluts)
            // For chute master screen
            if (response.data instanceof Object && response.data.hasOwnProperty(this.overlap)) {
              const resultOverlapData = response.data[this.overlap]
              // ユーザーがスクロールすると、結果のオーバーラップ データが元のオーバーラップ データに追加されます。
              resultOverlapData.map((data) => {
                if (this.overlapData.indexOf(data) === -1) {
                  this.overlapData.push(data)
                }
              })
              this.handleChuteGridOverlap(this.tableData)
            }
            data.state.loaded()
          }
        })
        .catch(err => {
          this.buildErrorMessage(err)
        })
    },
    async searchRequest(queryStr) {
      await this.fetchRequest(queryStr)
        .then(response => {
          this.initData(response)
          this.resetCheckAll()
        })
        .catch(err => {
          console.log(err)
          this.buildErrorMessage(err)
        })
    },
    // API handler methods to update - END
    // -----------------------------------
    // Build common message type - START
    buildSuccessMessage(actionType, isOverlap = false) {
      let msg = ''
      switch (actionType) {
        case INSERT_ACTION:
          msg = this.overlapMode
            ? '新規登録成功。'.concat(isOverlap ? '<br />ただし、重複したグリッドが設定されています。' : '')
            : '新規登録成功。'
          break
        case UPDATE_ACTION:
          msg = this.overlapMode
            ? '更新成功。'.concat(isOverlap ? '<br />ただし、重複したグリッドが設定されています。' : '')
            : '更新成功。'
          break
        case RESET_ACTION:
          msg = 'リセット完了。'
          break
        default:
          msg = '削除完了。'
          break
      }
      FlashMessage.getInstance().showSuccessMessage(msg)
    },
    buildErrorMessage(errMsg) {
      FlashMessage.getInstance().parseAndShowErrorMessage(errMsg)
    },
    // Build common message type - END
    isTaskStatementScreen() {
      return this.$route.name === AppConstants.TASK_STATEMENT_ROUTER_NAME
    },
    checkSocketMsgToReloadOtherPage(newMsg) {
      return AppConstants.ENTITIES_TO_RELOAD_PAGE[this.$route.name] && AppConstants.ENTITIES_TO_RELOAD_PAGE[this.$route.name].some(s => newMsg.indexOf(s) >= 0)
    },
    /**
     * ソケットメッセージが開発者設定更新の通知で、当テーブルが対象（追加上限ある）かどうかをチェック。
     * @param   {Array}   newMsg ソケットメッセージ
     * @returns {boolean}        当テーブルが対象の場合はtrue、そうでない場合はfalse
     */
    checkToReloadTableWithTotalRecordLimit(newMsg) {
      if (newMsg && newMsg.includes(AppConstants.DEV_SETTING_SOCKET)) {
        return AppConstants.ENTITIES_TO_RELOAD_PAGE_WHEN_DEV_SETTING_CHANGED.includes(AppConstants[this.socketEntity])
      }
      return false
    },
    async confirmDelete(dataDelete, removeConfirm, id) {
      this.$bvModal.hide(id)
      if (!removeConfirm) {
        let successMessage = this.endpointUri === URI_MAPPING_ENDPOINT ? 'リセットをキャンセルしました。' : '削除をキャンセルしました。'
        return FlashMessage.getInstance().showSuccessMessage(successMessage)
      }
      if (this.tableNo === DEV_SETTINGS_TABLE_NO && this.isDeleteConfirmationChecked) {
        await this.tackleDeleteFromDevSetting()
        return
      }
      this.resetLimitOffset()
      switch (dataDelete.modeDelete) {
        case DELETE_ALL_MODE:
          await this.tackleDeleteAll()
          break
        default:
          await this.tackleDeleteOnCheckedRows(dataDelete['data'])
          break
      }
      this.fetchDataForNewSocketMsg()
    },
    onClickDelete(modeDelete, data = null) {
      let dataRequest = {}
      dataRequest = {modeDelete}
      if (data || data === 0) {
        dataRequest['data'] = data
      }
      this.$refs.confirmationDeleteModal.show(dataRequest)
    },
    getSortCondition() {
      if (Object.keys(this.sort).length && Object.values(this.sort).every(value => !!value)) {
        return this.sortColumnByOrder()
      }
      return ''
    },
    isShowBatchDetail() {
      return RouterUtils.existedPropertyQueryObjectFromStorageByRouterName(this.$route.name, SHOW_BATCH_DETAILS_KEY)
    },
    /**
     * データテーブルの変更時にすべてのボタンスタイルをチェックするように変更
     */
    onChangeCheckAllButtonStyle(checkedList) {
      if (checkedList.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (checkedList.length === this.tableData.length || (this.handleShowCheckBox && checkedList.length === this.removeKeyOptional.length)) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    },
    /**
     * 列の値をリセットする
     * @param {string} keyName - キー名
     */
    resetValueOfColumn(keyName) {
      this.$set(this.queryPrameterValue, keyName, null)
      if (this.queryPrameterValue.hasOwnProperty(`after_${keyName}`)) {
        this.$set(this.queryPrameterValue, `after_${keyName}`, null)
      }
      if (this.queryPrameterValue.hasOwnProperty(`before_${keyName}`)) {
        this.$set(this.queryPrameterValue, `before_${keyName}`, null)
      }
    },
    /**
     * 非表示列の検索ソート値をリセットします。
     */
    resetHiddenColumnSearchSortValue() {
      for (let key in this.tableLabels) {
        let keyName = this.tableLabels[key]['isItemNo']
        let displayFlag = this.tableLabels[key]['displayFlag']
        // Reset the sort/search value of the column hidden
        if (!displayFlag) {
          // Reset the search value.
          this.resetValueOfColumn(keyName)
          // Reset sort order.
          if (this.sort.propetyName === keyName) {
            this.sort = { propetyName: null, order: null }
          }
        }
      }
    },
    /**
     * オーバーラップ グリッドのショットにアスタリスク アイコンを表示。
     *
     * シュートマスター画面用。
     * @param {array} tableData マスターテーブルのデータ。
     */
    handleChuteGridOverlap(tableData) {
      this.tableData = this.overlapMode && tableData
        ? tableData
          .map(data => ({...data, overlap: this.$_isOverlap(data.chuteSerialId) ? '＊' : ''}))
        : tableData
    },
    /**
     * アクションボタンの設定を初期化するメソッドです。
     * <br> このメソッドは、各ボタンに対応するラベル、URI、モーダルタイトル、および必要に応じて確認メッセージを設定します。
     */
    initializeActionButtonsConfig() {
      this.buttonActionsConfig = [
        {
          key: 'deleteAll',
          actionOptionLabel: 'タスク履歴・ログ画面のデータ削除',
          uri: '/delete-all',
          modalTitle: '「タスク履歴」「ログ」画面の全データを削除します。よろしいですか？'
        },
        {
          key: 'deleteTaskHistory',
          actionOptionLabel: 'タスク履歴画面のデータ削除',
          uri: '/taskhst',
          modalTitle: '「タスク履歴」画面の全データを削除します。よろしいですか？'
        },
        {
          key: 'deleteLog',
          actionOptionLabel: 'ログ画面のデータ削除',
          uri: '/log',
          modalTitle: '「ログ」画面の全データを削除します。よろしいですか？'
        },
        {
          key: 'resetMapping',
          actionOptionLabel: 'マッピング設定のリセット',
          uri: URI_MAPPING_ENDPOINT,
          modalTitle: '「マッピング設定」を初期状態にリセットします。よろしいですか？',
          confirmationDeleteMessage: '本当に実行してもよろしいでしょうか？'
        }
      ]
    },
    /**
     * アクションボタンがクリックされた際の処理を実行するメソッド。
     *
     * @param {string} uri - 操作対象のエンドポイント URI
     * @param {string} titleHeader - 確認モーダルのタイトルヘッダー
     * @param {string} confirmationDeleteMessage - 削除確認メッセージ
     */
    onClickActionButton(uri, titleHeader, confirmationDeleteMessage) {
      if (this.tableNo === DEV_SETTINGS_TABLE_NO) {
        this.isShowConfirmDeleteCheckBox = true
      }
      this.endpointUri = uri
      this.modalConfirmDeleteTitle = titleHeader
      this.confirmationDeleteMessage = confirmationDeleteMessage
      this.$refs.confirmationDeleteModal.show()
    },
    /**
     * ロックボタン押下時にテーブルのロック状態を切り替え、localStorage に保存する。
     */
    onClickLockButton() {
      this.isMasterTableUnlocked = !this.isMasterTableUnlocked
      const lockMasterKey = JSON.parse(localStorage.getItem(AppConstants.STORAGE_MASTER_TABLE_UNLOCK_STATE)) || {}
      lockMasterKey[this.tableNo] = this.isMasterTableUnlocked
      localStorage.setItem(AppConstants.STORAGE_MASTER_TABLE_UNLOCK_STATE, JSON.stringify(lockMasterKey))
    },
    /**
     * ロックボタンの状態を取得する。
     *
     * @param {boolean} isRestoreDataConfirmChecked - データ復元確認チェックボックスの状態
     */
    onRestoreDataAllowed(isRestoreDataConfirmChecked) {
      this.isRestoreDataConfirmChecked = isRestoreDataConfirmChecked
    },
    /**
     * CSVエクスポート成功時の処理。
     */
    handleExportSuccess() {
      this.isExportSuccess = true
    }
  }
}
</script>

<style lang="scss" scoped>
.table-toolbar {
  display: flex;
  justify-content: space-between;
  &__block-left {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &__block-right {
    .btn-lock {
      padding: 10px;
      display: flex;
      background: white;
      border-radius: 50%;
    }
  }
}
.empty_text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 20px;
  color: $text_gray;
}
.noMoreDataText {
  @include responsive-fs(12);
  color: $text_gray;
}
.icon_drag {
  @include responsive-fs(16);
  padding: 0 2px;
  font-weight: 500;
}
.icon_sort {
  @include responsive-fs(14);
  vertical-align: middle;
  padding: 0 2px;
  font-weight: 500;
}
.icon_filter {
  @include responsive-fs(15);
  padding: 0 2px;
  padding-bottom: 2px;
  vertical-align: middle;
}
.sort_th:hover {
  background-color: rgba(78, 102, 166, 0.08);
  cursor: pointer;
}
/deep/ th.sort_th .dropdown-menu {
    transform: translate3d(-95%, 18px, 0px) !important;
}

// 最初の列を選択します
/deep/ th.sort_th0 .dropdown-menu {
  border: none;
  box-shadow: -1px 1px 0px 0px $line_gray, 1px -1px 0px 0px $line_gray;
  transform: translate3d(-20%, 18px, 0px) !important;
}

// 2番目の列を選択します
/deep/ th.sort_th1 .dropdown-menu {
  transform: translate3d(-50%, 18px, 0px) !important;
}

/deep/ th.sort_th:last-child .dropdown-menu {
  transform: translate3d(-100%, 18px, 0px) !important;
}

// データ型がテキストまたはリストで列が 1 つだけの場合は、方向を右に表示します。
/deep/ th.data_type_0_1:last-child .dropdown-menu,
/deep/ th.data_type_2_1:last-child .dropdown-menu {
  transform: translate3d(-20%, 18px, 0px) !important;
}
.table_wrapper {
  height: 100% !important;
  padding: 0;
  margin-bottom: 0px !important;
  overflow: auto;
}
.mst_table_card {
  position: relative;
}
.table_wrapper thead{
  /* 縦スクロール時に固定する */
  position: sticky;
  top: 0;
  /* tbody内のセルより手前に表示する */
  z-index: 1;
}
table {
  border-collapse: separate;
  border-spacing: 0;
  @include responsive-fs(12);
  thead tr{
    background: #ffff;
    background-clip: padding-box;
    border-top: 1px solid #d6d6d6;
    box-shadow: 1px 0px 0px 2px #fff;
  }
  .sort_th {
    padding: 0 !important;
    border-top: none !important;
  }
}
.tableThead {
  padding: 0 5px !important;
  height: 47px !important;
}
.rowData {
  .edit_icon_detail {
    color: $sucess;
    @include responsive-fs(15);
  }
  td {
    // 600pxは全角50文字です
    max-width: 600px;
    @include textOverflowEllipsis
  }
}
.totalRecord {
  font-style: normal;
  font-weight: normal;
  @include responsive-fs(12);
}
.handle_btn_search {
  padding: 4px 8px;
  color: #252422 !important;
  background: rgba(78, 102, 166, 0.08) !important;
}
.btn_delete:active {
  color: $base_red !important;
  padding: 4px 8px;
  background: rgba(180, 27, 62, 0.08) !important;
}
.btn_search {
  border-radius: 4px;
  padding: 4px 8px;
  @include responsive-fs(12);
  .icon_search_btn {
    @include responsive-fs(14);
  }
}
.revertSortBtn {
  border-radius: 4px;
  @include responsive-fs(12);
  padding: 4px 8px;
  .revertSortIcon {
    @include responsive-fs(16);
  }
}
.btn_filter_clear {
  border-radius: 4px;
  @include responsive-fs(12);
  padding: 4px 8px;
  .icon_filter_clear_btn {
    @include responsive-fs(16);
  }
}
.btn_delete {
  border-radius: 4px;
  color: $base_red;
  padding: 4px 8px;
  @include responsive-fs(12);
  .icon_delete_btn {
    @include responsive-fs(16);
  }
  &:hover {
    color: $base_red;
  }
}
.btn_delete_all {
  border-radius: 4px;
  padding: 4px 8px;
  @include responsive-fs(12);
  .icon_delete_btn {
    @include responsive-fs(16);
  }
}
.btn_add {
  border-radius: 4px;
  padding: 4px 8px;
  @include responsive-fs(12);
  .icon_add_btn {
    @include responsive-fs(18);
  }
}
.btn[data-v-6d205d28] {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
.itemData{
  line-height: 2;
  &:hover {
    background: rgba(78, 102, 166, 0.08) !important;
    cursor: pointer;
    color: #4E66A6;
  }
}
.hideChbxAllColumn {
  margin-left: 20px;
}
.showChbxAllColumn {
  padding-left: .5rem;
}
.col_ordinal_number, .first_col {
  width: 48px !important;
  height: 47px !important;
  padding-top: 0px;
  padding-bottom: 0px;
  border-top: none !important;
}
.checkbox {
  z-index: 0;
}
.custom-tooltip {
  white-space: pre-wrap;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/CommonMasterTable.vue